import React from 'react';
export function Hero() {
  return <section className="w-full bg-transparent pt-2 pb-4 md:pt-2 md:pb-6" data-id="element-148">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-149">
        <div className="text-center space-y-2" data-id="element-150">
          <h1 className="md:text-5xl lg:text-6xl text-white font-[900] font-['Open_Sans',_sans-serif] text-[24px]" data-id="element-151">
            12 meses de sesiones <span className="text-[#D4A843]" data-id="element-152">listas</span>{' '}
            para usar desde hoy
          </h1>

          <div className="flex flex-col items-center pt-1 pb-1" data-id="element-153">
            <img src="https://cdn.magicpatterns.com/uploads/763rQyU54Vpdnd5Wjh4BZ3/5b69fe9a-6cee-4132-8e2b-0abb22a5427f.png" alt="Megapack Psicopedagogía Kit Profesional" className="w-full max-w-2xl h-auto pl-[80px] pr-[80px] mt-[5px] mb-[5px]" data-id="element-154" />
            <p className="md:text-xl mt-3 tracking-wide font-[700] font-['Open_Sans',_sans-serif] text-[#CAB072] text-[16px]" data-id="element-155">
              Ahorrá +300 horas al año y dejá de improvisar con un sistema listo
              para usar.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-2 text-xs md:text-sm text-gray-300 pt-2" data-id="element-156">
            <span className="flex items-center gap-1.5 border border-[#D4A843]/40 rounded-md px-3 py-1" data-id="element-157">
              📄 100% PDF
            </span>
            <span className="flex items-center gap-1.5 border border-[#D4A843]/40 rounded-md px-3 py-1" data-id="element-158">
              ⚡ Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5 border border-[#D4A843]/40 rounded-md px-3 py-1" data-id="element-159">
              🌍 Todo el país
            </span>
          </div>

          <div className="flex justify-center pt-2" data-id="element-160">
            <a href="#ofertas" className="inline-block bg-[#D4A843] hover:bg-[#B8912E] text-white font-bold px-8 py-4 rounded-lg transition-all duration-200 hover:scale-105 text-[14px] font-['Open_Sans',_sans-serif]" data-id="element-161">
              🧮→ QUIERO MI MEGAPACK AHORA
            </a>
          </div>
        </div>
      </div>
    </section>;
}